import { t } from 'i18next'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'

export const getAccessButtonAndInfo = ({ realtimeSubscriptionData } = {}) => {
  const userDetails = getLocalUserDetails()
  const realtimeSubscriptionName = (realtimeSubscriptionData?.subscriptionDetails?.SubscriptionName || '').trim()
  const subType = userDetails?.sub?.subType

  if (!userDetails) {
    return {
      buttonText: t('LOGIN_AND_CREATE_ACCOUNT'),
      infoMessage: t('TO_ACCESS_MORE_FEATURE_CREATE_ACCOUNT'),
      infoMessage2: t('TO_ACCESS_GLOBAL_DIFFERENTIAL_FEATURE'),
      className: 'login-button',
      navigationPath: ROUTE_STRINGS.login,
      state: {}
    }
  }

  if (userDetails.isTrialUser) {
    return {
      buttonText: t('BUY_TRIAL_SUBSCRIPTION'),
      infoMessage: t('TO_ACCESS_GLOBAL_DIFFERENTIAL_FEATURE'),
      className: 'buy-subscription-button',
      navigationPath: ROUTE_STRINGS.subscription,
      state: { subscriptionId: process.env.REACT_APP_NODE_ENV === 'production' ? 7 : 6 }
    }
  }

  if (realtimeSubscriptionName === 'Regular' || subType === 1) {
    return {
      buttonText: t('BUY_SUBSCRIPTION'),
      infoMessage: t('TO_ACCESS_GLOBAL_DIFFERENTIAL_FEATURE'),
      className: 'buy-subscription-button',
      navigationPath: ROUTE_STRINGS.subscription,
      state: { subscriptionId: 3 }
    }
  }

  if (realtimeSubscriptionName === 'Gold' || subType === 2) {
    return {
      buttonText: t('UPGRADE'),
      infoMessage: t('TO_ACCESS_GLOBAL_DIFFERENTIAL_FEATURE'),
      className: 'buy-subscription-button',
      navigationPath: ROUTE_STRINGS.subscription,
      state: { subscriptionId: 3 }
    }
  }

  return {
    buttonText: t('LOGIN_AND_CREATE_ACCOUNT'),
    infoMessage: t('TO_ACCESS_MORE_FEATURE_CREATE_ACCOUNT'),
    className: 'login-button',
    navigationPath: ROUTE_STRINGS.login,
    state: {}
  }
}
